import React from "react";
import Navbar from "./components/Navbar";
import Header from "./components/Header";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import './css/styles.css';
import Certificates from "./components/Certificates";
import { useEffect, useState } from "react";


function App() {
    const[message, setMessage] = useState("");

    useEffect(() => {
        // Component mount olduğunda backend'e GET isteği
        fetch("https://selcukyapicicomtr-backend-1.onrender.com/api/visit", {
            method: "POST",
            headers: {
                "Content-Type": "application/json", //JSON gönderdiğini belirtir
            },
            body: JSON.stringify({
                page: "home", //Backend'e göndermek istediğin örnek veri
                timestamp: new Date(),
            }),
        })
            .then((res) => {
                if (!res.ok) throw new Error("Network response was not ok");
                return res.json(); // Backend JSON dönüyorsa
            })
            .then((data) => setMessage(data.message || data)) // Mesajı state'e ata
            .catch((err) => console.error("Backend request failed:", err));
    }, []); // [] -> sadece component mount olduğunda çalışır


    return (
        <>
            <Navbar />
            <Header />
            <About />
            <Certificates/>
            <Services />
            <Portfolio />
            <Contact />
            <Footer />

        </>
    );
}

export default App;
